export const barData=[
    {data: '25px' ,color:"#DBDFF1"},
    {data: '27px' ,color:"#DBDFF1"},
    {data: '28px' ,color:"#DBDFF1"},
    {data: '31px' ,color:"#DBDFF1"},
    {data: '31px' ,color:"#DBDFF1"},
    {data: '24px' ,color:"#DBDFF1"},
    {data: '31px',color:"#DBDFF1"},
    {data: '38px' ,color:"#DBDFF1"},
    {data: '36px' ,color:"#DBDFF1"},
    {data: '36px' ,color:"#DBDFF1"},
    {data: '31px',color:"#DBDFF1"},
    {data: '31px' ,color:"#DBDFF1"},
    {data: '38px' ,color:"#DBDFF1"},
    {data: '31px',color:"#DBDFF1"},
    {data: '24px' ,color:"#DBDFF1"},
    {data: '14px' ,color:"#DBDFF1"},
        {data: '19px',color:"#DBDFF1"},
        {data: '18px',color:"#DBDFF1"},
        {data: '14px',color:"#DBDFF1"},
        {data: '14px',color:"#FF708B"},
    {data: '14px' ,color:"#FF708B"},
    {data: '16px' ,color:"#FF708B"},
    {data: '17px' ,color:"#FF708B"},
    {data: '19px' ,color:"#FF708B"},
    {data: '25px' ,color:"#FF708B"},
    {data: '27px' ,color:"#FF708B"},
    {data: '28px' ,color:"#FF708B"},
    {data: '14px' ,color:"#FF708B"},
    {data: '14px' ,color:"#FF708B"},
    {data: '14px' ,color:"#FF708B"},
    {data: '24px' ,color:"#FF708B"},
    {data: '14px' ,color:"#DBDFF1"},
    {data: '18px' ,color:"#DBDFF1"},
    {data: '17px' ,color:"#DBDFF1"},
    {data: '14px' ,color:"#DBDFF1"},
    {data: '14px' ,color:"#DBDFF1"},
    {data: '18px' ,color:"#DBDFF1"},
    {data: '14px' ,color:"#DBDFF1"},
    {data: '24px' ,color:"#DBDFF1"},
    {data: '14px' ,color:"#DBDFF1"},
    
    {data: '14px'  ,color:"#DBDFF1"},
    {data: '14px' ,color:"#DBDFF1"},
    {data: '16px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '13px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '22px' ,color:"#DBDFF1"},
    {data: '21px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '22px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '13px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '24px' ,color:"#DBDFF1"},
    {data: '22px' ,color:"#DBDFF1"},
    {data: '22px' ,color:"#DBDFF1"},
    {data: '22px' ,color:"#DBDFF1"},
    {data: '22px' ,color:"#DBDFF1"},
    {data: '22px' ,color:"#DBDFF1"},
    {data: '19px' ,color:"#DBDFF1"},
    {data: '9px' ,color:"#DBDFF1"},
    {data: '9px' ,color:"#DBDFF1"},
    
]